import React from "react";
import ModalLayout from "../../ModalLayout";
import { ErrorModalStyled } from "./style";
import ErrorInfo from './errorInfo';
import OopsInfo from './oopsInfo';
import ErrorInfoPhoneNumber from './errorInfoPhoneNumber';
var ErrorModal = function (_a) {
    var onExit = _a.onExit, type = _a.type, onClick = _a.onClick;
    return (React.createElement(ModalLayout, { onExit: onExit },
        React.createElement(ErrorModalStyled, null,
            type == "error" && React.createElement(ErrorInfo, { onClick: onClick }),
            type == "oops" && React.createElement(OopsInfo, { onClick: onClick }),
            type == "errorPhone" && React.createElement(ErrorInfoPhoneNumber, { onClick: onClick, onExit: onExit }))));
};
export default ErrorModal;
